import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {buildDateBucketGroupFilter} from '@toolify/client/src/modules/databases/utils/buildDateBucketGroupFilter'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  useValueTypeStrategy,
} from '@toolify/client/src/modules/databases/strategies/PropertyValueTypeStrategy/composables/useValueTypeStrategy'

export function useCreatedAtPropertyTypeStrategy() {

  const getRestrictedEditReason = (): RestrictedEditReasonType | null => {
    return null
  }

  const getGroupGranularityDescriptor = (property: IDatabasePropertyResponseInstance): IGroupGranularityDescriptor | null => {
    return useValueTypeStrategy(property.valueType).groupGranularity ?? null
  }

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    return buildDateBucketGroupFilter(group, groupItem?.value, {
      rangeSubProperty: 'dateTime',
      emptySubProperty: 'dateTime',
    })
  }

  return {
    getRestrictedEditReason,
    getGroupFilter,
    getGroupGranularityDescriptor,
  }
}
